import { FC } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { NotificationTarget } from "@datagame/ui";
import { Route, Routes } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import { AppLayout } from "./components/app/AppLayout";
import { ForgotPasswordPage, LoginPage, RegistrationPage } from "./pages/account";
import { ActivatePage } from "./pages/ActivatePage";
import { InvitePage } from "./pages/account/InvitePage";
import { ProjectPage } from "./pages/ProjectPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { SubscriptionRoute } from "./SubscriptionRoute";
import { SubscriptionPage } from "./pages/SubscriptionPage";
import { CompanyPage } from "./pages/CompanyPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { ReportPage } from "./pages/ReportPage";
import { ProfilePage } from "./pages/ProfilePage";
import { LibraryPage } from "./pages/LibraryPage";

const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

export const AppRoutes: FC = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });
  return (
    <>
      <NotificationTarget
        position={isDesktop ? "bottom-right" : "top-center"}
        toastOptions={{
          duration: 4000,
        }}
      />
      <Routes>
        <Route
          path="/"
          element={
            <Elements stripe={stripePromise}>
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            </Elements>
          }
        >
          <Route path="activate" element={<ActivatePage />} />

          <Route path="/" element={<SubscriptionRoute />}>
            <Route index={true} element={<ProjectsPage />} />
            <Route path="library" element={<LibraryPage />} />
            <Route path="company" element={<CompanyPage />} />
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route path="project" element={<ProjectPage />} />
            <Route path="reports/:projectId" element={<ReportPage />} />
          </Route>
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        <Route path="register" element={<RegistrationPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="invite" element={<InvitePage />} />
        <Route path="public/reports/:projectId" element={<ReportPage isPublicDisplay={true} />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
